<template>
  <div v-if="slidebanner !== null">
    <!-- 橫幅廣告資訊 -->
    <div class="block mb-5">
      <!-- BU -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-5">
          <h4>BU</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <div class="w-248px my-n2">
            <v-autocomplete
              v-model="slidebanner.bu_id"
              :items="buTabs"
              placeholder="請選擇所屬BU"
              item-text="name"
              item-value="id"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </label>
      <!-- Title -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>標題</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-textarea
            v-model="slidebanner.title"
            outlined
            dense
          ></v-textarea>
        </div>
      </div>
      <!-- Description -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>副標題</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-textarea
            v-model="slidebanner.description"
            outlined
            dense
          ></v-textarea>
        </div>
      </div>
      <!-- Order -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="slidebanner.order"
            placeholder="請輸入序號"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- banner position -->
      <div class="form-item d-flex pb-5 mt-5 align-center">
        <h4 class="w-180px mr-35px">Banner Position</h4>
        <div class="flex-grow-1">
          <v-radio-group row v-model="slidebanner.position">
            <div
              v-for="position in ['left', 'right']"
              :key="position"
              class="w-50"
            >
              <v-radio class="mr-01" :value="position">
                <template v-slot:label>
                  <div class="ink-01-emphasis--text w-202px">
                    {{ position }}
                  </div>
                </template>
              </v-radio>
            </div>
          </v-radio-group>
        </div>
      </div>
      <!-- banner type [image or video]-->
      <div class="form-item d-flex pb-5 mt-5 align-center">
        <h4 class="w-180px mr-35px">Banner Type</h4>
        <div class="flex-grow-1">
          <v-radio-group row v-model="slidebanner.type">
            <div
              v-for="type in ['image']"
              :key="type"
              class="w-50"
            >
              <v-radio class="mr-01" :value="type">
                <template v-slot:label>
                  <div class="ink-01-emphasis--text w-202px">
                    {{ type }}
                  </div>
                </template>
              </v-radio>
            </div>
          </v-radio-group>
        </div>
      </div>
      <!-- banner type = Image -->
      <div v-if="slidebanner.type == 'image'">
        <!-- url -->
        <label class="form-item d-flex">
          <h4 class="w-180px my-5 mr-6">URL</h4>
          <div class="flex-grow-1 mt-3">
            <v-text-field
              v-model="slidebanner.url"
              prepend-inner-icon="mdi-link"
              outlined
              dense
            ></v-text-field>
          </div>
        </label>
      </div>
      <!-- banner type = Video -->
      <div v-if="slidebanner.type == 'video'">
        <!-- upload type -->
        <div class="form-item d-flex pb-5 mt-5 align-center">
          <h4 class="w-180px mr-35px">UploadType</h4>
          <div class="flex-grow-1">
            <v-radio-group v-model="slidebanner.upload_type" row>
              <div
                v-for="uploadType in [
                  {
                    label: '自電腦上傳影片',
                    value: 'file',
                  },
                  {
                    label: '來自Youtube/Youku連結',
                    value: 'link',
                  },
                ]"
                :key="uploadType.value"
                class="w-50"
              >
                <v-radio class="mr-01" :value="uploadType.value">
                  <template v-slot:label>
                    <div class="ink-01-emphasis--text w-202px">
                      {{ uploadType.label }}
                    </div>
                  </template>
                </v-radio>
              </div>
            </v-radio-group>
          </div>
        </div>
      </div>
      <!-- banner type = Video, upload type = 自電腦上傳影片 -->
      <div v-if="slidebanner.type == 'video' && slidebanner.upload_type == 'file'">
        <!-- 影片上傳 -->
        <div class="form-item d-flex px-5 pt-5 pb-5">
          <div class="w-200px">
            <h4 class="mb-10px">影片</h4>
            <div class="h5 ink-02-medium--text">
              影片支援格式：.mp4, .mov, .avi <br />
              檔案大小限制：&lt; 10 MB
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <FileUploader
              v-model="slidebanner.url"
              dir="bu_videos"></FileUploader>
          </div>
        </div>
      </div>
      <!-- banner type = Video, upload type = 來自Youtube/Youku連結 -->
      <div v-if="slidebanner.type == 'video' && slidebanner.upload_type == 'link'">
        <!-- Youtube -->
        <label class="form-item d-flex">
          <h4 class="w-180px my-5 mr-6">影片連結</h4>
          <div class="flex-grow-1 my-3">
            <v-text-field
              v-model="slidebanner.url"
              prepend-inner-icon="mdi-link"
              outlined
              dense
            ></v-text-field>
          </div>
        </label>
      </div>
      <!-- 顯示/隱藏 -->
      <div class="form-item d-flex pb-5 mt-5 align-center">
        <h4 class="w-180px mr-35px">Status</h4>
        <FormSwitch v-model="slidebanner.status"></FormSwitch>
      </div>
      <!-- img upload -->
      <div class="d-flex px-5 pt-5 mb-8">
        <div class="w-180px">
          <h4 class="mb-2">Visual</h4>
          <div class="h5 ink-02-medium--text">
            建議尺寸：999px * 999px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <ImgUploader
            :imageUrl.sync="slidebanner.visual"
            dir="bu_videos"></ImgUploader>
        </div>
      </div>
      <!-- img upload -->
      <div class="d-flex px-5 pt-5 mb-8">
        <div class="w-180px">
          <h4 class="mb-2">Visual for Mobile</h4>
          <div class="h5 ink-02-medium--text">
            建議尺寸：500px * 650px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <ImgUploader
            :imageUrl.sync="slidebanner.mobile_visual"
            dir="bu_videos"></ImgUploader>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import FormSwitch from '@/components/FormSwitch.vue';
import ImgUploader from '@/components/ImgUploader.vue';
import FileUploader from '@/components/FileUploader.vue';

export default {
  components: {
    FormSwitch,
    ImgUploader,
    FileUploader,
  },
  data: () => ({
    tab: '',
    isShow: false,
    isTop: false,
  }),
  computed: {
    ...mapState('language', ['countries']),
    ...mapState(['buTabs']),
    ...mapState('slidebanner', ['slidebanner']),
  },
  methods: {
  },
};
</script>

<style></style>
